import Image from 'next/image'
import Link from 'next/link'

import { cn } from '~/lib/utils'
import { useTracking } from '~/providers/tracking-provider'

export const CalendarLink = ({ link, className, size }: any) => {
	const { track } = useTracking()

	return (
		<Link
			data-testid={link['data-testid']}
			href={link.value}
			target='_blank'
			className={cn('flex flex-row gap-2', className)}
			onClick={() => track.calendarShare(link.text)}
		>
			<Image
				src={link.icon}
				width={size}
				height={size}
				alt={link.text}
			/>

			{link.text}
		</Link>
	)
}
